<template>
    <password-change-form ref="form" title="Password change" buttonText="Save changes" @save="onPasswordSave($event)"></password-change-form>
</template>

<script>
    import axios from 'axios';
    import swal from 'sweetalert2';
    import PasswordChangeForm from '../components/auth/PasswordChangeForm';
    import * as Sentry from "@sentry/vue";

    export default {
        name: 'account-login-details-page',
        components: {PasswordChangeForm},
        methods: {
            resetData() {
                this.$refs.form.resetData();
            },
            onPasswordSave({password, passwordConfirmation}) {
                axios.post(
                    "/api/?entity=user&action=updatePassword",
                    {
                        password,
                        password_confirmation: passwordConfirmation,
                    }
                ).then((result) => {
                    this.resetData();

                    swal.fire({
                        title: 'Sweet!',
                        text: 'Your password is successfully changed.',
                        type: 'success',
                    });
                }).catch(error => {
                    const {data} = error.response || {};
                    if (data && data.errors && data.errors.password) {
                        swal.fire({
                            title: 'UhOh!',
                            text: data.errors.password[0],
                            type: 'error',
                            confirmButtonText: 'Ok',
                            buttonsStyling: false,
                            confirmButtonClass: 'btn btn-lg btn-primary'
                        });
                    } else {
                      Sentry.captureException(error);
                    }
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    legend {
        margin-bottom: 0;
    }
</style>
